<template>
  <el-form @submit.native.prevent="submitForm" label-position="top" class="form-custom">
    <template v-for="(field, index) in schema.fields">
      <el-form-item
        v-if="isFieldVisible(field)"
        :key="`${field.name}-${index}`"
        :label="field.type === 'checkbox' ? '' : field.label"
        :error="fieldError(field.name)"
      >
        <el-select
          v-if="field.type === 'select'"
          v-model="model[field.name]"
          :disabled="isDisabled(field)"
          :placeholder="field.placeholder || field.label"
          filterable
          clearable
          class="form-custom__control"
        >
          <el-option
            v-for="option in normalizeOptions(field.list)"
            :key="`${field.name}-${option.value}`"
            :label="option.text"
            :value="option.value"
          />
        </el-select>

        <el-input
          v-else-if="field.type === 'textarea'"
          v-model="model[field.name]"
          :disabled="isDisabled(field)"
          :placeholder="field.placeholder"
          type="textarea"
          :rows="5"
          class="form-custom__control"
        />

        <el-date-picker
          v-else-if="field.type === 'datepicker'"
          v-model="model[field.name]"
          :disabled="isDisabled(field)"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="Select date"
          class="form-custom__control"
        />

        <el-upload
          v-else-if="field.type === 'file'"
          action=""
          :auto-upload="false"
          :show-file-list="true"
          :limit="1"
          :disabled="isDisabled(field)"
          :on-change="handleUploadChange"
          :on-exceed="handleUploadExceed"
          class="form-custom__upload"
        >
          <el-button size="small" icon="el-icon-upload2">Select file</el-button>
          <div slot="tip" class="el-upload__tip">{{ field.placeholder || field.label }}</div>
        </el-upload>

        <el-checkbox
          v-else-if="field.type === 'checkbox'"
          v-model="model[field.name]"
          :disabled="isDisabled(field)"
        >
          {{ field.label }}
        </el-checkbox>

        <el-input
          v-else
          v-model="model[field.name]"
          :disabled="isDisabled(field)"
          :placeholder="field.placeholder"
          class="form-custom__control"
        />
      </el-form-item>
    </template>

    <div class="form-custom__actions">
      <el-button :loading="loading" type="primary" native-type="submit">Save</el-button>
      <el-button :disabled="loading" @click="cancelForm">Cancel</el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    schema: {
      type: Object,
      require: true,
    },
    model: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {},
    }
  },
  mounted: async function () {
    this.data = this.model
  },
  methods: {
    isFieldVisible(field) {
      return field.show != undefined ? field.show : true
    },
    isDisabled(field) {
      return field.disabled ? field.disabled : false
    },
    fieldError(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) && this.veeErrors.has(ref)) {
        return this.veeErrors.first(ref)
      }
      return ''
    },
    normalizeOptions(list) {
      return (list || []).map((item) => {
        if (typeof item === 'object') {
          return {
            value: item.value,
            text: item.text != null ? item.text : item.value,
          }
        }

        return {
          value: item,
          text: item,
        }
      })
    },
    submitForm: function (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.$emit('commit', this.data)
      })
    },
    cancelForm: function () {
      this.$emit('revert', this.data._id)
    },
    handleUploadChange(file) {
      if (file && file.raw) {
        this.$emit('fileUpload', { file: file.raw, e: file })
      }
    },
    handleUploadExceed() {
      this.$message.warning('Please select only one file.')
    },
  },
}
</script>

<style scoped>
.form-custom__control {
  width: 100%;
}

.form-custom__upload {
  width: 100%;
}

.form-custom__actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
}
</style>
